import { useMemo } from "react";
import { getPassVerifiedData, PASS_VERIFIED_NAME } from "@jti/fe-common";
import { useFormContext } from "../../components/Form";
export const useNameFromAv = ({ firstnameField, isSingleNameField, lastnameField }) => {
    const { setValue } = useFormContext();
    const isNameAutopopulated = useMemo(() => {
        const passVerifiedName = getPassVerifiedData(PASS_VERIFIED_NAME);
        if (passVerifiedName && typeof passVerifiedName === "string") {
            if (isSingleNameField) {
                setValue(lastnameField, passVerifiedName);
                return true;
            }
            // NOTE : FOR NOW - it is dead code , as this logic is for KOR with isSingleNameField, prepared for future
            const [name, lastname] = passVerifiedName.split(" ");
            setValue(firstnameField, name);
            setValue(lastnameField, lastname);
            return true;
        }
        return false;
    }, [isSingleNameField, lastnameField, firstnameField, setValue]);
    return {
        isNameAutopopulated,
    };
};
//# sourceMappingURL=useNameFromAv.js.map